import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F8F7FC]">
                <div className="text-center">
                    <Loader2 className="w-12 h-12 animate-spin text-zinc-400 mx-auto mb-4" />
                    <p className="text-zinc-600 font-medium">Loading...</p>
                </div>
            </div>
        );
    }

    if (user === false) {
        return <Navigate to="/login" replace />;
    }

    return children;
}
